import { render } from "./RestaurantIdsInput.vue?vue&type=template&id=46f63a2c&scoped=true&ts=true"
import script from "./RestaurantIdsInput.vue?vue&type=script&lang=ts"
export * from "./RestaurantIdsInput.vue?vue&type=script&lang=ts"

import "./RestaurantIdsInput.vue?vue&type=style&index=0&id=46f63a2c&scoped=true&lang=css"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f63a2c"]])

export default __exports__